import { callEdgeFunction } from "./edgeFunctionClient";
import { splitWholeBookPdf } from "./pdfBookSplitter";

const callSpeakingContent = (firebaseUser, action, payload = {}) => (
    callEdgeFunction("speaking-content-manager", firebaseUser, { action, ...payload })
);

// 每題片段（聽這題）由獨立的 speaking-clip-manager 處理。
const callSpeakingClips = (firebaseUser, action, payload = {}) => (
    callEdgeFunction("speaking-clip-manager", firebaseUser, { action, ...payload })
);

export const getSpeakingContentBootstrap = firebaseUser => callSpeakingContent(firebaseUser, "bootstrap");
export const prepareSpeakingSourceUpload = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "create_document_upload", payload);
export const extractSpeakingSourceDocument = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "extract_document", payload);
export const reviewSpeakingOcrSource = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "review_ocr_source", payload);
export const saveReviewedSpeakingSource = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "save_reviewed_source", payload);
export const generateSpeakingQuestionSet = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "generate_question_set", payload);
export const confirmPageCandidateSpeakingDraft = (firebaseUser, questionSetId) => callSpeakingContent(firebaseUser, "confirm_page_candidate_draft", {
    question_set_id: questionSetId,
    confirmed: true
});
export const createWorkbookOneStarterQuestionSet = (firebaseUser, bookId) => callSpeakingContent(firebaseUser, "create_workbook_1_starter", { book_id: bookId });
export const createWorkbookOneFoundationQuestionSet = (firebaseUser, bookId, action) => callSpeakingContent(firebaseUser, action, { book_id: bookId });
export const confirmWorkbookOneFoundationSource = (firebaseUser, questionSetId) => callSpeakingContent(firebaseUser, "confirm_workbook_1_foundation_source", {
    question_set_id: questionSetId,
    confirmed: true
});
export const createWorkbookTwoStarterQuestionSet = (firebaseUser, bookId) => callSpeakingContent(firebaseUser, "create_workbook_2_starter", { book_id: bookId });
export const createWorkbookOnePictureDraft = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "create_workbook_1_picture_draft", payload);
export const createManualSpeakingDraft = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "create_manual_speaking_draft", payload);
export const createManualPageSpeakingDraft = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "create_manual_page_speaking_draft", payload);
export const getWorkbookOnePictureReviewCandidates = (firebaseUser, pageLabel) => callSpeakingContent(firebaseUser, "get_workbook_1_picture_review_candidates", {
    page_label: pageLabel
});
export const discardWorkbookOnePictureDraft = (firebaseUser, questionSetId) => callSpeakingContent(firebaseUser, "discard_workbook_1_picture_draft", {
    question_set_id: questionSetId
});
export const updateDraftSpeakingQuestion = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "update_draft_question", payload);
export const createSpeakingQuestionSetRevision = (firebaseUser, questionSetId) => callSpeakingContent(firebaseUser, "create_question_set_revision", {
    question_set_id: questionSetId
});
export const listSpeakingQuestionClips = (firebaseUser, questionSetId) => callSpeakingClips(firebaseUser, "list_question_clips", {
    question_set_id: questionSetId
});
export const importSpeakingQuestionClips = (firebaseUser, questionSetId, clips) => callSpeakingClips(firebaseUser, "import_question_clips", {
    question_set_id: questionSetId, clips
});
export const reviewSpeakingQuestionClip = (firebaseUser, clipId, decision) => callSpeakingClips(firebaseUser, "review_question_clip", {
    clip_id: clipId, decision
});
export const updateSpeakingQuestionSetDraft =(firebaseUser, payload) => callSpeakingContent(firebaseUser, "update_question_set_draft", payload);
export const updatePictureDraftQuestion = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "update_picture_draft_question", payload);
export const addPictureDraftQuestion = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "add_picture_draft_question", payload);
export const updateManualStandardQuestion = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "update_manual_standard_question", payload);
export const addManualStandardQuestion = (firebaseUser, payload) => callSpeakingContent(firebaseUser, "add_manual_standard_question", payload);
export const deleteDraftSpeakingQuestion = (firebaseUser, questionSetId, questionId) => callSpeakingContent(firebaseUser, "delete_draft_question", {
    question_set_id: questionSetId, question_id: questionId
});
export const reorderDraftSpeakingQuestions = (firebaseUser, questionSetId, questionIds) => callSpeakingContent(firebaseUser, "reorder_draft_questions", {
    question_set_id: questionSetId, question_ids: questionIds
});
export const archiveSpeakingQuestionSet = (firebaseUser, questionSetId) => callSpeakingContent(firebaseUser, "archive_question_set", {
    question_set_id: questionSetId
});
export const archiveSpeakingSourceSection = (firebaseUser, sourceSectionId) => callSpeakingContent(firebaseUser, "archive_source_section", {
    source_section_id: sourceSectionId
});
export const publishSpeakingQuestionSet = (firebaseUser, questionSetId) => callSpeakingContent(firebaseUser, "publish_question_set", { question_set_id: questionSetId });
export const generateSpeakingQuestionSetAudio = (firebaseUser, questionSetId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, { action: "generate_set_audio", question_set_id: questionSetId })
);
export const prepareSpeakingAlphabetAudioCandidate = (firebaseUser, questionSetId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, {
        action: "prepare_alphabet_audio_candidate", question_set_id: questionSetId
    })
);
export const activateSpeakingAlphabetAudioCandidate = (firebaseUser, questionSetId, candidateId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, {
        action: "activate_alphabet_audio_candidate", question_set_id: questionSetId, candidate_id: candidateId
    })
);
export const getSpeakingQuestionAudioPreview = (firebaseUser, questionSetId, questionId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, {
        action: "preview_question_audio", question_set_id: questionSetId, question_id: questionId
    })
);
export const getPictureGapTheAudioCandidates = (firebaseUser, questionSetId, questionId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, {
        action: "preview_picture_gap_the_candidates", question_set_id: questionSetId, question_id: questionId
    })
);
export const activatePictureGapTheAudioCandidate = (firebaseUser, questionSetId, questionId, candidateId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, {
        action: "activate_picture_gap_the_candidate",
        question_set_id: questionSetId,
        question_id: questionId,
        candidate_id: candidateId
    })
);
export const restorePictureGapStandardAudio = (firebaseUser, questionSetId, questionId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, {
        action: "restore_picture_gap_standard_audio",
        question_set_id: questionSetId,
        question_id: questionId
    })
);
export const getSpeakingQuestionPicturePreview = (firebaseUser, questionId) => (
    callSpeakingContent(firebaseUser, "preview_question_picture", { question_id: questionId })
);
export const generateSpeakingVisibleWordAudio = (firebaseUser, questionSetId) => (
    callEdgeFunction("speaking-tts-manager", firebaseUser, { action: "generate_visible_word_audio", question_set_id: questionSetId })
);
export const extractSpeakingBookChunk = (firebaseUser, chunkId) => callSpeakingContent(firebaseUser, "extract_book_chunk", { chunk_id: chunkId });
export const discardSpeakingSourceUpload = (firebaseUser, documentId) => callSpeakingContent(firebaseUser, "discard_document_upload", { document_id: documentId });

export const uploadSpeakingQuestionPicture = async (firebaseUser, questionId, pageLabel, altZh, file) => {
    const prepared = await callSpeakingContent(firebaseUser, "create_picture_upload", {
        question_id: questionId,
        source_page_label: pageLabel,
        alt_zh: altZh,
        mime_type: file.type,
        byte_size: file.size
    });
    try {
        const response = await fetch(prepared.upload.url, {
            method: prepared.upload.method || "PUT",
            headers: prepared.upload.headers || { "Content-Type": file.type },
            body: file
        });
        if (!response.ok) throw new Error(`私人圖片上傳失敗（HTTP ${response.status}）`);
        return await callSpeakingContent(firebaseUser, "confirm_picture_upload", {
            question_id: questionId,
            asset_id: prepared.asset_id
        });
    } catch (error) {
        await callSpeakingContent(firebaseUser, "discard_picture_upload", { asset_id: prepared.asset_id }).catch(() => null);
        throw error;
    }
};

const uploadPrivatePdf = async (upload, body) => {
    let response;
    try {
        response = await fetch(upload.url, {
            method: upload.method || "PUT",
            headers: upload.headers || { "Content-Type": "application/pdf" },
            body
        });
    } catch (error) {
        const currentOrigin = typeof window !== "undefined" && window.location?.origin
            ? `（${window.location.origin}）`
            : "";
        throw new Error(`無法連線到私人教材儲存空間。請在 R2 CORS AllowedOrigins 加入目前來源${currentOrigin}，並允許 PUT 與 Content-Type 後再重試。`, { cause: error });
    }
    if (!response.ok) throw new Error(`私人教材上傳失敗（HTTP ${response.status}）`);
};

const runUploadPool = async (items, concurrency, worker) => {
    let cursor = 0;
    const runners = Array.from({ length: Math.min(concurrency, items.length) }, async () => {
        while (cursor < items.length) {
            const current = cursor;
            cursor += 1;
            await worker(items[current]);
        }
    });
    await Promise.all(runners);
};

export const uploadWholeBookSource = async (firebaseUser, file, metadata, onProgress = () => {}) => {
    onProgress({ phase: "splitting", completed: 0, total: 1 });
    const { pageCount, chunks } = await splitWholeBookPdf(file, { onProgress });
    onProgress({ phase: "preparing", completed: 0, total: chunks.length + 1, pageCount });
    const prepared = await callSpeakingContent(firebaseUser, "create_book_upload", {
        book_id: Number(metadata.book_id),
        document_title: metadata.document_title,
        original_filename: file.name,
        byte_size: file.size,
        page_count: pageCount,
        chunks: chunks.map(({ blob, ...chunk }) => chunk)
    });
    let completed = 0;
    try {
        await uploadPrivatePdf(prepared.original_upload, file);
        completed += 1;
        onProgress({ phase: "uploading", completed, total: chunks.length + 1, pageCount });
        await runUploadPool(prepared.chunk_uploads, 3, async upload => {
            const chunk = chunks.find(item => item.chunk_index === upload.chunk_index);
            if (!chunk) throw new Error("找不到對應的 PDF 批次");
            await uploadPrivatePdf(upload, chunk.blob);
            completed += 1;
            onProgress({ phase: "uploading", completed, total: chunks.length + 1, pageCount });
        });
        const confirmed = await callSpeakingContent(firebaseUser, "confirm_book_upload", { document_id: prepared.document_id });
        onProgress({ phase: "ready", completed: chunks.length + 1, total: chunks.length + 1, pageCount });
        return { ...confirmed, chunks: prepared.chunk_uploads };
    } catch (error) {
        await discardSpeakingSourceUpload(firebaseUser, prepared.document_id).catch(() => null);
        throw error;
    }
};

export const uploadAndExtractSpeakingSource = async (firebaseUser, file, metadata) => {
    const prepared = await prepareSpeakingSourceUpload(firebaseUser, {
        book_id: metadata.book_id,
        document_title: metadata.document_title,
        original_filename: file.name,
        mime_type: file.type,
        byte_size: file.size
    });
    const uploadResponse = await fetch(prepared.upload.url, {
        method: prepared.upload.method || "PUT",
        headers: prepared.upload.headers || { "Content-Type": file.type },
        body: file
    });
    if (!uploadResponse.ok) {
        await callSpeakingContent(firebaseUser, "discard_document_upload", { document_id: prepared.document_id }).catch(() => null);
        throw new Error(`私人教材上傳失敗（HTTP ${uploadResponse.status}）`);
    }
    try {
        return await extractSpeakingSourceDocument(firebaseUser, { ...metadata, document_id: prepared.document_id });
    } catch (error) {
        error.documentId = prepared.document_id;
        throw error;
    }
};
